module.exports = __webpack_public_path__ + "media/img/ruby-ico-large-970ba6e3.png";